import { initReactI18next } from 'react-i18next'
import i18next from 'i18next'
import Backend, { HttpBackendOptions } from 'i18next-http-backend'
import { z } from 'zod'
import { zodI18nMap } from 'zod-i18n-map'
import translation from 'zod-i18n-map/locales/pl/zod.json'
import gitInfo from '~root/git-info.json'

const format = (
  value: string | number,
  format: string | undefined,
  lng: string = 'pl'
) => {
  if (
    format === 'number' &&
    typeof value === 'number' &&
    !Number.isNaN(value)
  ) {
    return Intl.NumberFormat(lng).format(value)
  }
  return value.toString()
}

const version =
  (import.meta.env.NODE_ENV === 'production' && gitInfo.commitHash) ||
  new Date().getTime()

i18next
  .use(Backend)
  .use(initReactI18next)
  .init<HttpBackendOptions>({
    partialBundledLanguages: true,
    lng: 'pl',
    fallbackLng: 'pl',
    supportedLngs: ['pl'],
    interpolation: {
      escapeValue: false,
      format,
    },
    react: {
      transKeepBasicHtmlNodesFor: ['br', 'strong', 'em'],
    },
    saveMissing: true, // send not translated keys to endpoint
    resources: {
      pl: {
        zod: translation,
      },
    },
    backend: {
      // allow cross domain requests
      crossDomain: false,
      loadPath: `/{{lng}}/{{ns}}.json?cb=${version}`,
      addPath: `http://localhost:5171/locales/add/{{lng}}/{{ns}}.json`,
    },
  })

z.setErrorMap(zodI18nMap)

export default i18next
